// ─────────────────────────────────────────────────────────────────────────────
// i18n/locales/pt.ts – Português
// ─────────────────────────────────────────────────────────────────────────────
export default {
  lang: { de: 'Deutsch', fr: 'Français', it: 'Italiano', en: 'English', es: 'Español', pt: 'Português' },

  nav: {
    // Menuepunkt der Uebersichtsseite (T-M41.3) — eigener Schluessel neben
    // `nav.dashboard`, das zwei andere Stellen beschriftet.
    overview:     'Visão geral',
    dashboard:    'Painel',
    jobs:         'Trabalhos de impressão',
    fleet:        'Frota',
    printers:     'Impressoras',
    schankanlage: 'Sistema de bebidas',
    printserver:  'Servidor de impressão',
    settings:     'Configurações',
    users:        'Usuários',
    company:      'Empresa',
    locations:    'Locais',
    smtp:         'E-Mail SMTP',
    api:          'API',
    switchCompany:'Trocar empresa',
    selectCompany:'Selecionar empresa',
    logout:       'Sair',
  },

  common: {
    save:          'Salvar',
    saving:        'Salvando …',
    cancel:        'Cancelar',
    delete:        'Excluir',
    deleting:      'Excluindo …',
    edit:          'Editar',
    add:           'Adicionar',
    back:          'Voltar',
    loading:       'Carregando …',
    search:        'Pesquisar …',
    yes:           'Sim',
    no:            'Não',
    confirm:       'Confirmar',
    confirmDelete: 'Realmente excluir?',
    cannotUndo:    'Esta ação não pode ser desfeita.',
    new:           'Novo',
    optional:      '(opcional)',
    unknown:       '—',
    active:        'Ativo',
    inactive:      'Inativo',
    enabled:       'Habilitado',
    disabled:      'Desabilitado',
    seconds:       'seg.',
    minutes:       'min.',
    noData:        'Nenhum dado disponível.',
    close:         'Fechar',
    remove:        'Remover',
    copy:          'Copiar',
    copied:        'Copiado!',
    change:        'Alterar',
    send:          'Enviar',
    sending:       'Enviando …',
    processing:    'Processando …',
    show:          'Mostrar',
    hide:          'Ocultar',
    yesDelete:     'Sim, excluir',
    yesRemove:     'Sim, remover',
    note:          'Nota',
    error:         'Erro',
    version:       'Versão',
    // Kennzahl, die NICHT serverseitig gezaehlt ist: Untergrenze (REQ-OPS-034)
    count: {
      atLeast:      'Pelo menos {count}',
      atLeastShort: '≥ {count}',
      atLeastHint:  'Derivado da lista carregada – pelo menos estes, possivelmente mais.',
    },
    // Blaettern statt Kuerzen (REQ-OPS-032/033, T-M8.19b) — die zwei Texte,
    // die in JEDER geblaetterten Liste gleich lauten.
    pagination: {
      liveFirstPageOnly: 'Apenas a primeira página é atualizada em tempo real.',
      loadFailed:        'Falha ao carregar mais.',
    },
  },

  status: {
    online:   'Online',
    offline:  'Offline',
    printing: 'Imprimindo',
    error:    'Erro',
    ready:    'Pronto',
    pending:  'Pendente',
    done:     'Concluído',
    // Estado de entrega `completed` (REQ-DM-040) — ver de.ts.
    completed: 'Entregue',
    failed:   'Falhou',
    expired:  'Expirado',
  },

  role: {
    admin:    'Administrador',
    user:     'Usuário',
  },

  auth: {
    email:              'Endereço de e-mail',
    password:           'Senha',
    passwordNew:        'Nova senha',
    passwordNewLabel:   'Nova senha *',
    passwordConfirm:    'Confirmar senha',
    passwordConfirmLabel:'Confirmar senha *',
    passwordMinHint:    'Pelo menos 8 caracteres',
    passwordRepeat:     'Repetir senha',
    passwordMismatch:   'As senhas não coincidem.',
    passwordTooWeak:    'A senha é muito fraca (pelo menos 8 caracteres).',
    passwordSave:       'Salvar senha',
    passwordSaved:      'Senha salva!',
    passwordSavedHint:  'Sua senha foi alterada com sucesso. Você será redirecionado automaticamente …',
    toDashboard:        'Ir ao painel',
    linkInvalid:        'Link inválido',
    linkInvalidHint:    'Este link expirou ou já foi utilizado. Por favor, solicite um novo link.',
    toLogin:            'Ir ao login',
    setNewPassword:     'Definir nova senha',
    setNewPasswordHint: 'Digite sua nova senha para',
    welcomeBack:        'Bem-vindo de volta',
    welcomeHint:        'Faça login com sua conta.',
    login:              'Entrar',
    loggingIn:          'Entrando …',
    logout:             'Sair',
    forgotPassword:     'Esqueceu a senha?',
    resetPassword:      'Redefinir senha',
    resetSent:          'E-mail enviado. Por favor, verifique sua caixa de entrada.',
    backToLogin:        'Voltar ao login',
    sessionExpired:     'A sua sessão expirou (12 horas). Por favor, faça login novamente.',
    footer:             'Payfix AG · Sistema de gestão de impressão · v1.0',
    strength: {
      weak:      'Fraca',
      medium:    'Média',
      strong:    'Forte',
      veryStrong:'Muito forte',
    },
    errors: {
      invalidEmail:    'Endereço de e-mail inválido.',
      wrongPassword:   'Senha incorreta.',
      userNotFound:    'Nenhum usuário encontrado com este e-mail.',
      tooManyRequests: 'Muitas tentativas. Por favor, aguarde.',
      generic:         'Falha no login. Por favor, tente novamente.',
      occurred:        'Ocorreu um erro.',
    },
  },

  invitation: {
    title:        'Aceitar o convite',
    subtitle:     'Defina a sua senha para criar a sua conta.',
    submit:       'Criar conta',
    working:      'Criando a conta …',
    successTitle: 'A sua conta está pronta',
    successHint:  'Você será conectado e redirecionado …',
    errInvalid:   'Este convite não é válido. Solicite um novo convite.',
    errExpired:   'Este convite expirou. Solicite um novo convite.',
    errExists:    'Já existe uma conta para este endereço. Faça login com a sua senha atual.',
    errFailed:    'Não foi possível aceitar o convite. Nada foi criado; tente novamente.',
  },

  bootstrap: {
    errorTitle: 'A inicialização falhou',
    errorHint:  'Não foi possível concluir o início de sessão. Tente novamente ou inicie sessão novamente.',
    errorHintNoProfile: 'Não existe nenhum perfil de utilizador para esta conta. Contacte o seu administrador.',
    errorCode:  'Código de erro: {code}',
    retry:      'Tentar novamente',
    reLogin:    'Iniciar sessão novamente',
  },

  // T-M21.5 / REQ-OPS-054: o aviso NOMEIA as áreas afetadas e não mostra
  // NENHUMA hora — a hora da última atualização recebida não é registada.
  liveVerbindung: {
    title:     'Atualização em tempo real interrompida',
    areas:     'Já não está em tempo real: {areas}',
    hint:      'Os dados apresentados provêm da última atualização recebida e podem estar desatualizados. Só voltarão a ser atualizados quando a ligação for restabelecida.',
    reconnect: 'Ligar novamente',
    quiet:     'Ligação interrompida: {areas}',
    area: {
      jobs:         'Trabalhos de impressão',
      printers:     'Impressoras',
      printservers: 'Servidores de impressão',
      companies:    'Empresas',
      locations:    'Locais',
      registers:    'Caixas',
      users:        'Usuários',
      apiTokens:    'Tokens de API',
    },
  },

  fleet: {
    title:          'Frota',
    subtitle:       'Servidores de impressão por local – estado, versão e filas ao vivo.',
    empty:          'Ainda não há servidores de impressão',
    emptyHint:      'Assim que um servidor de impressão for configurado, aparece aqui.',
    noLocation:     'Sem local',
    noServers:      'Nenhum servidor de impressão neste local',
    noPrinters:     'Sem impressoras',
    unassignedPrinters: {
      text:   'Uma impressora aguarda atribuição | {count} impressoras aguardam atribuição',
      hint:   'Estas impressoras foram criadas através da interface e não têm nenhum servidor de impressão atribuído. Não aparecem em nenhum grupo desta vista e só aceitarão trabalhos depois de lhes ser atribuído um servidor de impressão.',
      action: 'Atribuir na lista de impressoras',
    },
    locationOffline:'Local offline',
    serverCount:    '{n} servidores de impressão',
    version:        'Versão',
    versionUnknown: 'Desconhecida',
    versionOutlier: 'Divergente',
    versionOutlierHint: 'Difere da versão da frota v{version}.',
    lastPing:       'Último sinal de vida',
    pending:        '{n} em espera',
    queueEmpty:     'Sem trabalhos em espera',
    pendingAtLeast: 'Pelo menos {n} em espera',
    queueUnknown:   'Fila desconhecida',
    queueUnknownHint: 'Não foi possível contar a fila. Isso não significa que esteja vazia.',
    queueHeldHeading: 'Retidos ({n})',
    queueHeldHint:    'Estes trabalhos só são impressos quando a cozinha os marca como «Pronto para recolha». Por isso não têm posição na fila.',
    queueNoneWaiting: 'Nada aguarda pela impressora',
    time: {
      never:        'Nunca',
      justNow:      'Agora mesmo',
      minutes:      'Há {n} min',
      hours:        'Há {n} h',
      days:         'Há {n} dias',
    },
  },

  dashboard: {
    title:          'Painel',
    welcome:        'Bem-vindo',
    totalJobs:      'Total de trabalhos',
    totalPrinters:  'Total de impressoras',
    onlinePrinters: 'Impressoras online',
    printservers:   'Servidores de impressão',
    recentJobs:     'Trabalhos de impressão recentes',
    noJobs:         'Nenhum trabalho de impressão disponível.',
    heldJobs:       'Retidos',
    heldJobsHint:   'Estas comandas só são impressas quando a cozinha as marca como «Pronto para recolha». Não aguardam pela impressora e não são um congestionamento.',
  },

  printers: {
    title:         'Impressoras',
    subtitle:      'Todas as impressoras conectadas desta empresa',
    add:           'Adicionar impressora',
    empty:         'Nenhuma impressora cadastrada ainda',
    emptyHint:     'Adicione a primeira impressora desta empresa.',
    number:        'N.º',
    name:          'Nome',
    type:          'Tipo',
    printserver:   'Servidor de impressão',
    ipAddress:     'Endereço IP',
    pendingBons:   'Recibos abertos',
    deleteTitle:   'Excluir impressora?',
    deleteConfirm: 'Deseja realmente excluir {name}?',
    new:           'Nova impressora',
    edit:          'Editar',
    openKitchen:      'Abrir Kitchen TV',
    openAbholscreen:  'Abrir ecrã de retirada',
    openFastline:     'Abrir Fastline',
    // BERICHTIGT AM 2026-08-17 (T-M8.19b, REQ-OPS-032 neu gefasst): der
    // Schluessel bleibt, sein Wortlaut wird berichtigt statt geloescht. Bis
    // dahin sagte er „die Liste ist gekuerzt, weitere Drucker sind hier nicht
    // sichtbar" — eine Sackgasse. Die 100 sind ab jetzt die SEITENgroesse.
    limitReached:     'Existem mais impressoras desta empresa: é carregada uma página de {count} entradas — carregar mais.',
    loadMore:         'Carregar mais {count} impressoras',
    // Kurzform fuer das Nachladen IM Auswahlkontext (Drucker-Dropdown der
    // Auftragsliste): dort ist kein Platz fuer die Seitengroesse.
    loadMoreShort:    'Carregar mais impressoras …',
    loadedCount:      '{count} impressoras carregadas',
    endOfList:        'Fim da lista – todas as impressoras estão carregadas.',
    sections: {
      basic:       'Dados básicos',
      abholscreen: 'Configurações da tela de retirada',
      kitchenTv:   'Configurações do Kitchen TV',
      alarm:       'Alertas',
      status:      'Estado',
      screenAccess: 'Chave de exibição',
    },
    fields: {
      outputType:        'Tipo de saída',
      outputPrint:       'Impressora',
      outputKitchenTv:   'Kitchen TV / Tela',
      outputPrintHint:   'Impressora ESC/POS física com endereço e tipo de modelo.',
      outputKitchenTvHint: 'Canal de tela sem servidor de impressão, endereço ou tipo de modelo.',
      port:              'Porta',
      abholscreenEnabled: 'Tela de retirada ativa',
      abholscreenEnabledHint: 'Mostra os números dos pedidos prontos na tela de retirada.',
      displayDurationHint: 'Duração de exibição dos pedidos prontos, de 5 a 600 segundos (padrão 60 segundos).',
      autoCompleteDisabled:     'Desativar a conclusão automática',
      autoCompleteDisabledHint: 'Os pedidos prontos permanecem visíveis até serem concluídos manualmente — a duração de exibição deixa de os concluir. Quatro horas após a entrada são concluídos automaticamente na mesma; essa limpeza não pode ser desativada.',
      maxItems:          'Máx. números exibidos',
      maxItemsUnit:      'números',
      maxItemsHint:      'Limite de números exibidos simultaneamente (0 = ilimitado).',
      screenKeyHint:       'A chave de exibição conecta uma tela (Kitchen TV, tela de retirada, Fastline). Apenas o hash é armazenado; o texto simples não pode ser recuperado depois.',
      screenKeySaveFirst:  'Salve o canal primeiro, depois você poderá definir uma chave de exibição.',
      screenKeySet:        'Chave de exibição definida',
      screenKeyNotSet:     'Nenhuma chave de exibição',
      screenKeyPlaceholder:'Inserir ou gerar chave',
      screenKeyGenerate:   'Gerar',
      screenKeySave:       'Definir chave',
      screenKeyRotate:     'Rotacionar chave',
      screenKeyOnce:       'Esta chave é exibida apenas UMA vez. Anote-a agora com segurança.',
      screenKeyRequired:        'Exigir chave de exibição',
      screenKeyRequiredHint:    'Uma tela entra neste canal com a chave de exibição. Sem ela não obtém acesso.',
      screenKeyRequiredOffHint: 'Este canal está aberto sem chave de exibição: quem souber o endereço da tela lê os pedidos deste canal e define o estado de preparo deles. O acesso continua limitado a este canal e a esta empresa.',
      screenKeyRequiredOffPrintHint: 'Neste canal isso também aciona uma impressão: quem colocar um pedido em «Pronto para retirada» libera a comanda retida, e ela é impressa.',
      alarmEnabled:      'Alertas ativos',
      alarmEnabledHint:  'Notifica em caso de problemas na impressora (offline, erro).',
      alarmMuted:        'Silenciar completamente',
      alarmMutedHint:    'Suprime todos os alertas desta impressora.',
      alarmStages:       'Níveis de alerta',
      stage_offline:     'Offline',
      stage_paperLow:    'Papel quase acabando',
      stage_error:       'Erro',
      stage_coverOpen:   'Tampa aberta',
      // Stufe Papierende (T-M42.3, REQ-PS-023c) und Kennzeichnung unwirksamer
      // Stufen je Modelltyp (REQ-PS-023a Praez. 1 (a) / Praez. 3).
      stage_paperOut:    'Sem papel',
      stageIneffective:  'sem efeito',
      stageIneffectiveTitle: 'O tipo de modelo {model} não comunica este estado. O nível pode ser ativado, mas nunca gera um alerta nesta impressora.',
      stagesIneffectiveHint: 'Os níveis marcados «sem efeito» não são comunicados pelo tipo de modelo {model}: podem ser ativados, mas nunca geram um alerta nesta impressora.',
      // T-M42.10 Teil (b): die gesetzten Stufen wuerden mangels Einrichtung
      // am Mandanten nie versendet (Regel: utils/alarmEinrichtung.ts).
      alarmNotSetUpTypeDisabled: 'Alarmes não configurados: na central de alarmes da empresa «Falha da impressora» está desativado. Os níveis definidos aqui nunca são enviados.',
      alarmNotSetUpNoRecipients: 'Alarmes não configurados: na central de alarmes da empresa não há nenhum destinatário. Os níveis definidos aqui nunca são enviados.',
      printerId:         'ID da impressora',
      printerIdPlaceholder: 'p. ex. 3324',
      printerIdHint:     'O ID da impressora do portal Payfix — exatamente o valor que a caixa envia como printer_id. Não é um número à escolha: sem o ID correto nenhum talão chega a este canal.',
      designation:       'Nome',
      printerType:       'Tipo de impressora',
      printerServer:     'Servidor de impressão',
      ipAddress:         'Endereço IP',
      sameAddressHint:   'Mesmo endereço que «{name}». Ambos os canais imprimem um a seguir ao outro no mesmo aparelho.',
      company:           'Empresa',
      range:             'De / Até',
      rangeFrom:         'De',
      rangeTo:           'Até',
      tableRangesHint:   'Se estiverem definidos intervalos, este canal recebe apenas os talões de preparação e os recibos cujo número de mesa se encontra num dos intervalos. O mesmo vale para o Kitchen TV, a tela de retirada e o Fastline. Os documentos sem número de mesa – entre eles os fechos diários e as contas do pessoal – chegam sempre a este canal. Se não houver nenhum intervalo definido, recebe tudo.',
      qrCode:            'Imprimir código QR',
      qrCodeHint:        'Adiciona um código QR no recibo. É também o requisito para que os pedidos apareçam na tela de retirada desta impressora.',
      qrCodeOffByKitchenTv: 'O código QR no recibo permanece desativado enquanto a vista Kitchen TV estiver ativada — os dois nunca ficam ativos ao mesmo tempo na mesma impressora. Ativá-lo aqui desativa a vista Kitchen TV.',
      qrCodeOffByU220: 'A TM-U220 não imprime códigos QR. Neste modelo o interruptor está bloqueado e não tem efeito.',
      showName:          'Mostrar nome da impressora',
      colorWorking:      'Cor em processamento',
      colorReady:        'Cor pronto para retirada',
      displayDuration:   'Duração de exibição',
      preview:           'Visualização',
      kitchenTvEnabled:  'Kitchen TV',
      kitchenTvEnabledHint: 'Mostra também os pedidos desta impressora numa tela Kitchen TV. A impressora continua a ser uma impressora completa e continua a imprimir. Ao ativar, o código QR no recibo é desativado.',
      autoStartTimer:    'Iniciar temporizador automaticamente',
      autoStartTimerHint:'Inicia o temporizador automaticamente ao receber um pedido',
      disablePrintingWhenKitchenTv:     'Não imprimir os talões de preparação',
      disablePrintingWhenKitchenTvHint: 'Os talões de preparação deste canal deixam de ser impressos e são apenas apresentados no Kitchen TV. São considerados entregues de imediato e aparecem na lista de trabalhos com a nota «entregue sem impressão». Os talões de caixa continuam a ser impressos. Num canal apenas de ecrã, a definição não tem efeito, porque aí nunca se imprime.',
      fastline:          'Fastline',
      rangeRemove:       'Remover intervalo {n}',
      abholscreenUrl:    'URL do ecrã de retirada',
      kitchenTvUrl:      'URL Kitchen TV',
      kitchenTvUrlLight: 'URL Kitchen TV Light',
      fastlineUrl:       'URL Fastline',
    },
    // Der aktive Bildschirm-Modus, angezeigt statt eingestellt
    // (REQ-SC-106 (2), T-M25.5). Die drei Modusnamen sind Produktnamen und
    // stehen in allen sechs Sprachen gleich; die Feldwerte bleiben
    // technisch-englisch (REQ-OV-002, REQ-DM-068 (1)).
    screenMode: {
      label:    'Modo ativo',
      hint:     'Mostra qual ecrã conduz atualmente este canal. O modo é assumido no próprio ecrã, não aqui: quem abre um dos três endereços confirma aí a mudança e desativa assim o modo anterior.',
      mode_normal:   'Kitchen TV normal',
      mode_light:    'Kitchen TV Light',
      mode_fastline: 'Fastline',
      mode_none:     'nenhum modo ativo',
    },
    kitchenTvInactive: 'O Kitchen TV está desativado. Ative-o acima para ajustar as configurações.',
    kitchenTvAlwaysOn: 'Este canal é um canal de tela: a vista Kitchen TV funciona sempre aqui e não pode ser desativada.',
    // Druckerzustand: grob (status.*) plus feine Kennungen (REQ-PS-020a/021).
    // Werte bleiben technisch-englisch in Firestore, hier nur die Anzeige.
    status: {
      title:       'Estado atual',
      noDetail:    'Sem ocorrências',
      updatedAt:     'Estado inalterado desde',
      updatedAtHint: 'O momento da última ALTERAÇÃO de estado, não o do último aviso. O servidor de impressão escreve este valor apenas quando o estado muda; uma impressora permanentemente sem falhas mostra aqui, por isso, uma hora antiga.',
      never:         'Ainda sem estado comunicado',
      stale: {
        withAge:    'Desatualizado — último aviso há {age}',
        unknownAge: 'Desatualizado — idade desconhecida',
        age: {
          lessThanMinute: 'menos de um minuto',
          minute:  'um minuto',
          minutes: '{n} minutos',
          hour:    'uma hora',
          hours:   '{n} horas',
          day:     'um dia',
          days:    '{n} dias',
        },
        reason: {
          noPrintserver: 'Esta impressora não tem nenhum servidor de impressão atribuído. O estado é escrito exclusivamente pelo servidor de impressão: sem ele, o último valor escrito permanece indefinidamente.',
          noPing:        'O servidor de impressão responsável ainda não escreveu nenhum sinal de vida. Por isso não é possível dizer qual a idade do estado apresentado.',
          serverOffline: 'O servidor de impressão responsável está offline. Já não consegue comunicar o estado desta impressora; é apresentado o último valor escrito.',
          pingTooOld:    'O último sinal de vida do servidor de impressão responsável ultrapassa o limite de 90 segundos (três vezes o intervalo de 30 segundos). O estado apresentado é o último escrito e pode já não corresponder à realidade.',
        },
      },
      sourceLabel: 'Origem',
      levelLabel:  'Nível de detalhe',
      levelHint:   'Nível de detalhe que este modelo de impressora consegue fornecer.',
      detail: {
        offline:     'Inacessível',
        coverOpen:   'Tampa aberta',
        paperOut:    'Sem papel',
        cutterError: 'Erro do cortador',
        error:       'Erro da impressora',
        notResponding: 'Não responde',
        paperLow:    'Papel quase acabando',
      },
      source: {
        asb:        'Comunicado pela impressora',
        poll:       'Consulta ativa',
        jobResult:  'Deduzido do resultado de impressão',
        connection: 'Ligação interrompida',
      },
      level: {
        full:  'Completo',
        basic: 'Limitado',
        none:  'Sem retorno de estado',
      },
    },
    archived:     'Arquivada',
    archivedHint: 'Impressoras arquivadas já não aceitam trabalhos.',
    incomplete:     'Incompleta',
    // Corrigido em 2026-09-07 (T-M33.3, REQ-DM-072 (h)): desde T-M8.3, os
    // trabalhos dirigidos a uma impressora sem servidor de impressão são
    // recusados com 400 — não são aceites e depois deixados por entregar.
    incompleteHint: 'Esta impressora não tem servidor de impressão de destino. Só aceita trabalhos depois de lhe ser atribuído um servidor de impressão; até lá, os trabalhos enviados são recusados.',
    filter: {
      all:            'Todas',
      unassigned:     'Sem servidor de impressão ({count})',
      noneUnassigned: 'Todas as impressoras têm um servidor de impressão atribuído.',
    },
    quickAssign: {
      label:       'Atribuir servidor de impressão',
      placeholder: 'Atribuir servidor de impressão …',
      saving:      'A atribuir …',
      failed:      'Não foi possível guardar a atribuição. Tente novamente.',
      noServers:   'Não existe nenhum servidor de impressão registado para esta empresa.',
    },
    unassignedNotice: {
      title: 'Nenhum servidor de impressão atribuído',
      body:  'Esta impressora foi criada através da interface e só aceita trabalhos depois de lhe ser atribuído um servidor de impressão. Selecione um servidor de impressão abaixo e guarde.',
    },
    validation: {
      nameRequired:         'Introduza uma designação.',
      numberRequired:       'Introduza o ID da impressora do portal Payfix.',
      // NOVO 2026-09-18 (T-M41.8, REQ-DM-036 Praez. 4 (ix)).
      payfixPrinterIdInvalid: 'Este ID da impressora não pode ser guardado. Não são permitidos a barra, os valores «.» e «..», identificadores da forma «__…__» nem mais de 1500 bytes. Introduza o identificador registado para esta impressora no portal Payfix.',
      payfixPrinterIdTaken: 'O ID da impressora {id} já está atribuído à impressora «{name}» da empresa «{company}». Cada ID só pode existir uma vez — caso contrário o talão chega ao canal errado. Introduza o ID registado para esta impressora no portal Payfix.',
      payfixPrinterIdTakenOtherCompany: 'O ID da impressora {id} já está atribuído à impressora «{name}» da empresa «{company}» — ou seja, fora da empresa aqui selecionada, e essa impressora não lhe é visível. Cada ID só pode existir uma vez — caso contrário o talão chega ao canal errado. Contacte os responsáveis de «{company}» ou introduza o ID registado para esta impressora no portal Payfix.',
      payfixPrinterIdTakenOtherCompanyUnnamed: 'O ID da impressora {id} já está atribuído noutra empresa. Qual é essa empresa não é mostrado aqui — está fora do seu acesso. Cada ID só pode existir uma vez — caso contrário o talão chega ao canal errado. Contacte o suporte da Payfix ou introduza o ID registado para esta impressora no portal Payfix.',
      payfixPrinterIdTakenOrphaned: 'O ID da impressora {id} já está atribuído à impressora «{name}», e essa impressora não está associada a nenhuma empresa legível — um ID órfão. Por isso continua ocupado em todo o sistema, embora não seja possível encontrar nenhuma empresa. Introduza outro ID registado no portal Payfix e comunique o ID órfão à exploração.',
      payfixPrinterIdTakenOrphanedUnnamed: 'O ID da impressora {id} já está ocupado, e a impressora que o ocupa não está associada a nenhuma empresa legível — um ID órfão. Por isso continua ocupado em todo o sistema, embora não seja possível encontrar nenhuma empresa. Introduza outro ID registado no portal Payfix e comunique o ID órfão à exploração.',
      payfixPrinterIdCheckFailed: 'Não foi possível verificar o ID da impressora — a consulta está de momento inacessível. Nada foi guardado. Tente novamente dentro de instantes.',
      printserverRequired:  'Selecione um servidor de impressão. Sem servidor de destino o trabalho não é entregue.',
      modelTypeRequired:    'Selecione um tipo de modelo (Standard, U220 ou Sunmi).',
      ipAddressRequired:    'Introduza o endereço IP ou o nome de anfitrião da impressora. Sem endereço o servidor de impressão não a consegue comandar nem consultar o seu estado.',
      printserverForbidden: 'Um canal de ecrã não pode ter servidor de impressão.',
    },
    warnings: {
      abholscreenNeedsQrCode:       'A tela de retirada permanece vazia nesta impressora: sem a impressão do QR no recibo não aparece nenhum pedido. O QR impresso no recibo é o comprovativo de retirada do cliente. Ativar a impressão do QR mais tarde só vale para os pedidos novos — os pedidos já criados não aparecem retroativamente.',
      abholscreenNeedsQrCodeAction: 'Ativar a impressão do QR no recibo',
      abholscreenNeedsKitchenTvAction: 'Ativar a vista Kitchen TV',
      abholscreenNeedsQrCodeSave:   'Tela de retirada ativa, impressão do QR no recibo desativada: esta tela de retirada permanece vazia. Clique novamente em Salvar para salvar a configuração mesmo assim.',
    },
    notices: {
      displayDurationDisabled:     'Sem efeito: a conclusão automática está desativada',
      displayDurationDisabledHint: 'Enquanto a conclusão automática estiver desativada, nada expira ao fim desta duração. O valor permanece guardado e volta a ter efeito assim que a conclusão automática for reativada.',
    },
  },

  printserver: {
    title:              'Servidor de impressão',
    subtitle:           'Servidores de impressão conectados desta empresa',
    subtitleAllCompanies: 'Servidores de impressão conectados de todas as empresas',
    subtitleOwnCompanies: 'Servidores de impressão conectados das suas empresas',
    add:                'Adicionar servidor de impressão',
    empty:              'Nenhum servidor de impressão cadastrado ainda',
    emptyHint:          'Adicione o primeiro servidor de impressão.',
    name:               'Nome',
    uuid:               'UUID',
    uuidCopy:           'Copiar UUID',
    uuidLabel:          'UUID (gerado automaticamente)',
    uuidHint:           'Uma designação para as pessoas, não um valor de configuração: o daemon não lê o UUID. Para a configuração vale o ID do documento.',
    documentId:         'ID do documento',
    documentIdHint:     'O daemon lê este identificador como PRINTSERVER_ID do seu arquivo .env. Ele é atribuído na criação e não pode ser alterado.',
    documentIdPending:  'O identificador é criado ao salvar.',
    ipAddress:          'Endereço IP',
    anydeskId:          'ID do AnyDesk',
    anydeskIdMissing:   'O servidor de impressão informa o ID do AnyDesk ao iniciar. Se estiver ausente, o dispositivo ainda executa um software mais antigo que não o informa, ou o AnyDesk não está instalado nele ou o ID não pode ser lido.',
    company:            'Empresa',
    status:             'Status',
    connectedSince:     'Conectado desde',
    lastContact:        'Último contato',
    connectedMins:      'Conectado há {n} min.',
    connectedHrs:       'Conectado há {h} h {m} min.',
    lessThan1Min:       '< 1 min.',
    lastContactSec:     'há {n} seg.',
    lastContactMin:     'há {n} min.',
    lastContactHr:      'há {n} h.',
    nodeVersion:        'Versão do Node.js',
    appVersion:         'Versão do app',
    printerCount:       'Impressoras conectadas',
    printerCountValue:  '{n}',
    printerCountAtLeast:'pelo menos {n}',
    printerCountAtLeastHint: 'A lista de impressoras só está carregada página a página ({count} por página): o número é um limite inferior. Outras impressoras podem pertencer a este servidor de impressão; carregue mais.',
    printerCountUnknownHint: 'A lista de impressoras ainda não está disponível. O número aparece assim que ela for carregada.',
    runtimeFieldPending:'O servidor de impressão informa este campo na mudança de status (início ou parada). Dispositivos com software mais antigo ainda não o informam — o valor aparece após a próxima reinicialização.',
    updateAvailable:    'Atualização disponível: v{v}',
    restartControl:     'Controle de reinicialização',
    restartManual:      'Reinicialização manual',
    restartHint:        'Envia um comando de reinicialização para a aplicação Node.js na Raspberry Pi.',
    restartAfter:       'Reiniciar após (minutos)',
    restartNow:         'Reiniciar agora',
    restarting:         'Reiniciando …',
    // ⚠ `restartSent` ist am 2026-09-18 mit T-M41.9 in allen sechs Sprachen
    // ENTFALLEN; die Begründung steht am selben Ort in `de.ts`.
    // NOVO 2026-09-18 (T-M41.9): a confirmação do documento ao vivo substitui a
    // mensagem de sucesso após o clique — dois horários, nenhum veredicto.
    restartRequested:        'Reinicialização solicitada em {t}',
    restartNotAcknowledged:  'O dispositivo ainda não confirmou.',
    restartExecuted:         'Executado pelo dispositivo em {t}',
    restartReconnected:      'Reconectado desde {t}',
    autoRestartDelayHint: 'A alteração passa a valer no próximo arranque do launcher no dispositivo — tal como a hora de reinicialização. 0 = sem intervalo.',
    autoRestart:        'Reinicialização automática',
    autoRestartHint:    'O app será reiniciado automaticamente após este intervalo. 0 = desativado.',
    autoRestartDisabled:'A reinicialização automática está desativada.',
    autoRestartEnabled: 'O app será reiniciado a cada {n} minutos.',
    connectionInfo:     'Informações de conexão',
    connectionHint:     'A Raspberry Pi atualiza IP, versão e status automaticamente via Firestore heartbeat.',
    deleteTitle:        'Excluir servidor de impressão?',
    deleteConfirm:      'Deseja realmente excluir {name}?',
    cannotUndoFull:     'Deseja realmente excluir "{name}"? Esta ação não pode ser desfeita.',
    new:                'Novo servidor de impressão',
    stammdaten:         'Dados cadastrais',
    assignCompany:      'Associar empresa',
    noCompany:          '— Nenhuma empresa associada —',
    companyHint:        'O servidor de impressão aparecerá apenas para os usuários desta empresa.',
    companyPreset:      'Predefinido',
    companySearch:      'Procurar empresa …',
    companySelect:      'Selecionar empresa',
    companyNoMatch:     'Nenhuma empresa encontrada.',
    cascadeTitle:       'As impressoras perdem o seu servidor de impressão',
    cascadeText:        'Impressoras atribuídas a este servidor de impressão ({count}): {names}. Perdem a atribuição e não aceitam mais trabalhos até que lhes seja atribuído um servidor de impressão.',
    cascadeConfirm:     'Remover atribuição e continuar',
    companyRequired:    'Associe uma empresa. Se o servidor de impressão não deve mais pertencer a nenhuma empresa, exclua-o.',
    infoCard:           'Info',
    piSetup:            'Configuração do Raspberry Pi',
    piSetupHint:        'Insira este identificador no arquivo .env do daemon da Raspberry Pi:',
    piSetupPending:     'Salve primeiro o servidor de impressão. Depois aparecerá aqui o identificador para o arquivo .env do daemon da Raspberry Pi.',
    settingsTitle:      'Todos os servidores de impressão configurados – clique para abrir',
    settingsNoCompany:  '— Nenhuma empresa —',
    settingsAddFirst:   'Adicionar primeiro servidor de impressão',
    location:           'Local',
    noLocation:         '— Nenhum local associado —',
    locationHint:       'Associa o servidor de impressão a um local.',
  },

  locations: {
    title:            'Locais',
    subtitle:         'Todos os locais desta empresa',
    add:              'Adicionar local',
    empty:            'Nenhum local criado ainda',
    emptyHint:        'Adicione o primeiro local desta empresa.',
    name:             'Nome do local',
    namePlaceholder:  'p. ex. Sede principal Zurique',
    new:              'Novo local',
    edit:             'Editar',
    autoUpdate:       'Atualização automática',
    autoUpdateOn:     'Ativo',
    paused:           'Em pausa',
    updateSection:    'Atualização automática',
    updatePaused:     'Pausar atualização',
    updatePausedHint: 'Suspende a atualização automática dos servidores de impressão deste local.',
    updateChannel:    'Canal de atualização',
    channelStable:    'Estável',
    channelBeta:      'Beta',
    pinnedVersion:    'Versão fixada',
    pinnedVersionHint:'Deixe vazio para a versão mais recente no canal escolhido.',
    latest:           'Mais recente',
    deleteTitle:      'Excluir local?',
    deleteConfirm:    'Deseja realmente excluir {name}?',
  },

  jobs: {
    title:          'Trabalhos de impressão',
    subtitle:       'Todos os trabalhos de impressão desta empresa',
    new:            'Novo trabalho',
    empty:          'Nenhum trabalho de impressão disponível.',
    emptyFiltered:     'Nenhum dos trabalhos carregados corresponde aos filtros definidos.',
    emptyFilteredHint: 'É possível carregar mais trabalhos abaixo.',
    id:             'ID do trabalho',
    printer:        'Impressora',
    register:       'Caixa',
    status:         'Status',
    createdAt:      'Criado em',
    updatedAt:      'Última atualização',
    payload:        'Payload',
    create:         'Criar trabalho de impressão',
    send:           'Enviar trabalho de impressão',
    sending:        'Criando …',
    selectRegister: 'Selecionar caixa …',
    payloadLabel:   'JSON Payload (formato Payfix)',
    loadExample:    'Carregar exemplo',
    invalidJson:    'JSON inválido. Por favor, verifique.',
    created:        'Trabalho de impressão criado',
    sourcePayfix:   'Payfix',
    sourceDashboard:'Painel',
    source:          'Origem',
    type:            'Tipo',
    typePrintjobs:   'Trabalhos de impressão',
    typeReceipts:    'Recibos',
    statusAll:       'Todos',
    allPrinters:     'Todas as impressoras',
    allPrintservers: 'Todos os servidores de impressão',
    cashier:         'Colaborador',
    positions:       'Itens',
    total:           'Total',
    received:        'Recebido',
    printed:         'Impresso',
    paymentMethod:   'Forma de pagamento',
    items:           'Itens',
    posName:         'Artigo',
    posQty:          'Quantidade',
    posUnit:         'Preço unitário',
    posTotal:        'Total',
    subtotal:        'Subtotal',
    tax:             'IVA',
    noItems:         'Nenhum item disponível.',
    resend:          'Reenviar',
    deleteTitle:     'Eliminar o trabalho de impressão?',
    deleteConfirm:   'Deseja realmente eliminar o trabalho {id}?',
    loadMore:          'Carregar mais trabalhos',
    loadingMore:       'A carregar …',
    loadedCount:       '{count} trabalhos carregados',
    endOfList:         'Fim da lista – todos os trabalhos estão carregados.',
    loadMoreError:     'Falha ao carregar mais trabalhos.',
    liveFirstPageOnly: 'Apenas a primeira página é atualizada em direto.',
    device:          'Dispositivo',
    deleteError:     'Falha ao eliminar.',
    resendError:     'O reenvio falhou. O trabalho não foi criado.',
    resendNoPrintserver: 'Reenvio não possível: o canal não tem nenhum servidor de impressão atribuído (os canais de ecrã não podem ser impressos).',
    deliveryStatus:  'Estado de entrega',
    printerName: {
      idHint:         'Identificador da impressora: {id}',
      unresolved:     'Nome não resolúvel',
      unresolvedHint: 'Não existe nenhum canal com este identificador na lista de impressoras carregada; provavelmente foi eliminado. Identificador: {id}',
      notLoaded:      'Nome não carregado',
      notLoadedHint:  'A lista de impressoras só está carregada página a página, por isso o nome deste canal ainda não aparece. Isto não diz se o canal ainda existe: carregue mais impressoras. Identificador: {id}',
    },
    workStatus: {
      label:              'Estado de preparação',
      columnHint:         'Segunda dimensão de estado, independente: apenas os pedidos (talões de preparação) têm um estado de preparação. Os talões de caixa não têm nenhum, por isso o seu campo permanece vazio. Só é apresentado nos canais com a vista Kitchen TV ativada; em todas as outras linhas o campo permanece igualmente vazio — no detalhe do trabalho o valor continua aí visível assim que se afasta de «Aberto».',
      open:               'Aberto',
      inPreparation:      'Em preparação',
      ready:              'Pronto para levantamento',
      done:               'Concluído',
      unknown:            'Desconhecido',
      unknownHint:        'Este valor não faz parte do vocabulário previsto.',
      notPrintedDoneHint: 'Não é uma contradição: a entrega e a preparação são duas indicações distintas. O trabalho nunca chegou ao destino, mas foi encerrado operacionalmente (automaticamente ao fim de quatro horas).',
      readOnly:           'Apenas visualização – o estado de preparação não é alterado aqui.',
    },
    // Omissão registada no talão (REQ-PR-037, complemento REQ-DM-030,
    // T-M11.12).
    omitted: {
      badge:       'Talão incompleto',
      badgeHint:   'O trabalho foi entregue, mas o modelo de impressora não conseguiu executar alguns comandos do talão. O detalhe expandido indica o que foi omitido.',
      title:       'Comandos não executados',
      position:    'Posição',
      opcode:      'Opcode',
      opcodeNone:  'nenhum comando concreto',
      reasonLabel: 'Motivo',
      unknownHint: 'Este valor não faz parte do vocabulário previsto.',
      reason: {
        unsupportedByModel: 'Não suportado pelo modelo de impressora',
        emptyPayload:       'Sem dados úteis',
        invalidParameter:   'Parâmetro inválido',
        unflushedBuffer:    'Memória de linha não emitida',
        unknownOpcode:      'Comando de impressão desconhecido',
        logoUnreadable:     'Logo não imprimível',
        unknown:            'Desconhecido',
      },
      detail: {
        cut:      'Corte completo',
        textline: 'Memória de linha',
        unknown:  'Desconhecido',
      },
    },
    deliveredWithoutPrint: {
      badge:     'Entregue sem impressão',
      badgeHint: 'Este trabalho não foi impresso intencionalmente: o canal apresenta os talões de preparação apenas no ecrã. É considerado entregue no momento da receção e por isso não tem qualquer hora de impressão.',
      title:     'Entregue sem impressão',
      timeLabel: 'Entregue (sem impressão)',
    },
    deliveryConfirmation: {
      badge:     'Entregue sem confirmação da impressora',
      badgeHint: 'Este modelo de impressora não confirma a impressão; apenas a transmissão foi medida.',
    },
    // Pré-visualização do conteúdo do recibo (REQ-OPS-060, T-M29.3) — apenas
    // leitura e expressamente NÃO uma pré-visualização de impressão. Nenhum
    // comando é omitido em silêncio (REQ-PR-020).
    belegVorschau: {
      title:               'Conteúdo do recibo (pré-visualização)',
      abweichungsHinweis:  'Não é uma pré-visualização de impressão: o recibo impresso pode diferir disto. A largura das linhas, o tamanho do texto e as imagens só surgem na impressora.',
      u220Hinweis:         'Este recibo usa a linguagem de comandos da TM-U220. Não existe pré-visualização para ela — os mesmos números de comando têm ali outro significado, uma exibição seria adivinhada em vez de lida.',
      leerHinweis:         'Este recibo não contém comandos de impressão.',
      platzhalter: {
        align:           'Alinhamento',
        textSize:        'Tamanho do texto',
        cut:             'Corte',
        qr:              'Código QR',
        image:           'Imagem',
        textEmpty:       'Comando de texto sem conteúdo',
        unknown:         'Comando desconhecido {opcode} na posição {position}',
        unknownNoOpcode: 'Comando sem número na posição {position}',
      },
    },
  },

  settings: {
    title: 'Configurações',

    company: {
      title:            'Empresas',
      subtitle:         'Todas as empresas registradas',
      eyebrow:          'Configurações · Empresa',
      add:              'Adicionar empresa',
      empty:            'Nenhuma empresa cadastrada ainda.',
      name:             'Nome da empresa',
      nameLabel:        'Nome da empresa *',
      email:            'E-mail',
      phone:            'Telefone',
      address:          'Endereço',
      city:             'Cidade',
      zip:              'CEP',
      country:          'País',
      logo:             'Logo',
      description:      'Descrição',
      descriptionHint:  'Notas internas …',
      companyData:      'Dados da empresa',
      bonSettings:      'Configurações de recibo',
      bonLogo:          'Logo do recibo',
      bonLogoHint:      'Aparece no topo do recibo do cliente e do recibo de cancelamento, na conta parcial conforme o interruptor abaixo, não em fechamentos nem em impressoras TM-U220. PNG, JPG ou SVG, máx. 2 MB; é reduzido à largura de impressão e impresso em preto e branco.',
      bonLogoDrop:      'Solte o logo aqui ou clique para selecionar',
      // T-M51.4 (REQ-DM-010a Praez. 1 (2)/(4)): Meldungen der Logo-Erfassung,
      // die Beschriftung der Druckvorschau und der Hinweis unter Schlusstext
      // und QR-Code-URL.
      bonLogoFileTooLarge:   'O arquivo tem mais de 2 MB.',
      bonLogoResultTooLarge: 'Mesmo reduzido, o logo é grande demais para ser salvo. Escolha um arquivo mais simples.',
      bonLogoNotImage:       'Não foi possível ler o arquivo como imagem.',
      bonLogoPrintPreview:   'Prévia de impressão (preto e branco)',
      bonFooterQrHint:       'Aparecem no final do recibo do cliente, na conta parcial conforme os interruptores abaixo, não em recibos de cancelamento nem em fechamentos, nem em impressoras TM-U220.',
      // T-M54.5 (REQ-DM-010a Praez. 2 (4)): Kartenueberschrift und die drei
      // Schalter der Zwischenrechnung mit ihrem Hinweis.
      receiptSettings:       'Configurações de recibos',
      interimReceiptLogo:    'Imprimir logo na conta parcial',
      interimReceiptFooter:  'Imprimir texto final na conta parcial',
      interimReceiptQr:      'Imprimir código QR na conta parcial',
      interimReceiptHint:    'Aplica-se à conta parcial do caixa, em impressoras Epson e Sunmi, não em impressoras TM-U220. O que não estiver preenchido acima também não é impresso na conta parcial.',
      bonFooter:        'Rodapé do recibo',
      qrUrl:            'URL do código QR',
      usersSection:     'Usuários',
      usersSubtitle:    'Usuários desta empresa e seus direitos de edição',
      addUser:          'Adicionar usuário',
      noUsers:          'Nenhum usuário atribuído ainda',
      userCol:          'Usuário',
      emailCol:         'E-mail',
      removeUser:       'Remover usuário?',
      removeUserConfirm:'Deseja remover este usuário da empresa?',
      existingUser:     'Usuário existente',
      inviteByEmail:    'Convidar por e-mail',
      userSearch:       'Pesquisar usuários …',
      noUsersFound:     'Nenhum usuário encontrado',
      inviteSent:       'Convite enviado para {email}!',
      inviteEmailHint:  'O usuário receberá um e-mail com um link para definir sua senha.',
      systemRole:       'Função do sistema',
      roleUser:         'Usuário',
      roleAdmin:        'Administrador',
      deleteTitle:      'Excluir empresa?',
      deleteConfirm:    'Deseja realmente excluir {name}?',
      cannotUndoFull:   'Deseja realmente excluir "{name}"? Esta ação não pode ser desfeita.',
      payfixId:         'ID de cliente Payfix',
      payfixIdHint:     'Atribuído pela Payfix e não editável.',
      receiptFooter:    'Texto final do recibo',
      footerPlaceholder:'Obrigado pela sua compra!',
      alarmCenter:      'Central de alarmes',
      alarmSectionSub:  'Notificações automáticas em caso de problemas',
      emailAlarm:       'Alarme por e-mail',
      emailAlarmHint:   'Notificações por e-mail',
      alarmWhen:        'Quando deve ser alertado?',
      triggerQueueOffline:      'Fila offline',
      triggerQueueOfflineDesc:  'Notificação quando a fila do servidor de impressão fica offline',
      triggerNotPrinted:        'Trabalho de impressão não impresso (10 min)',
      triggerNotPrintedDesc:    'Notificação quando um recibo ainda não foi impresso após 10 minutos',
      triggerPrinterOffline:    'Falha da impressora',
      // `alarmOnPrinterOffline` traegt ALLE Drucker-Stufen, nicht nur `offline`
      // (T-M42.10); bis zum 2026-09-26 lautete der Text „Drucker Offline“.
      triggerPrinterOfflineDesc:'Notificação para cada nível de alarme ativado na impressora (offline, erro, papel quase acabando, tampa aberta, sem papel)',
      // T-M42.10 Teil (b): Alarmierung nicht eingerichtet (utils/alarmEinrichtung.ts).
      alarmNotSetUp:             'Alarmes não configurados',
      alarmNotSetUpNoType:       'Nenhum tipo de alarme está ativado. De momento, não é enviado nenhum alarme para esta empresa.',
      alarmNotSetUpNoRecipients: 'Não há nenhum destinatário: ative o alarme por e-mail e introduza pelo menos um endereço. Até lá, não é enviado nenhum alarme para esta empresa.',
      alarmNotSetUpSavedState:   'Vale o estado guardado.',
    },

    users: {
      title:           'Usuários',
      subtitle:        'Todos os usuários desta empresa',
      eyebrow:         'Configurações · Usuários',
      add:             'Convidar usuário',
      empty:           'Nenhum usuário disponível ainda.',
      searchEmpty:     'Nenhum usuário encontrado para «{search}».',
      name:            'Nome',
      email:           'E-mail',
      role:            'Função',
      status:          'Status',
      lastLogin:       'Último acesso',
      data:            'Dados do usuário',
      emailHint:       'O e-mail não pode ser alterado após a criação.',
      inviteHint:      'O usuário receberá um e-mail de convite para definir sua senha.',
      roleAccess:      'Função e acesso',
      internalNote:    'Nota interna',
      internalNotePH:  'Responsabilidades, departamento …',
      noAccount:       'Nenhuma conta de login disponível',
      noAccountHint:   'Este usuário foi criado sem uma conta do Firebase Auth e não pode fazer login. Envie um e-mail de convite para corrigir isso.',
      inviteSent:      'Convite enviado!',
      inviteSentHint:  'Um e-mail foi enviado para {email}. O usuário pode usá-lo para definir sua senha.',
      deleteTitle:     'Excluir usuário?',
      deleteConfirm:   'Deseja realmente excluir "{name}"? O usuário perderá o acesso imediatamente.',
      invite:          'Enviar convite',
      invited:         'Convidado',
      companies:       'Empresas',
      companiesHint:   'O usuário vê e opera os dados destas empresas.',
      // Para a função `admin` esta nota substitui a lista de caixas
      // (REQ-SEC-030 prec. 1 (c), REQ-SEC-027 (a) — T-M38.4).
      companiesAdminHint: 'Os administradores têm acesso a todas as empresas; não é necessária nenhuma atribuição.',
      companiesNone:   'Ainda não atribuído a nenhuma empresa.',
      companySearch:   'Procurar empresa …',
      companyNoMatch:  'Nenhuma empresa encontrada.',
      companyLimit:    'Um usuário pode ter no máximo {max} empresas. Remova primeiro uma empresa.',
      companyRequired: 'Selecione pelo menos uma empresa para o convite.',
      invitations:     'Convites em aberto',
      openInvitation:  'Convite em aberto',
      validUntil:      'Válido até {date}',
      expiredOn:       'Expirou em {date}',
      reinvite:        'Convidar novamente',
      inviteFailed:    'Não foi possível enviar o convite.',
    },

    smtp: {
      title:            'E-Mail SMTP',
      subtitle:         'Configurações para envio de e-mail',
      infoText:         'Estas configurações SMTP são para e-mails personalizados. O Firebase Auth envia e-mails do sistema de forma independente.',
      serverConnection: 'Conexão ao servidor',
      authentication:   'Autenticação',
      sender:           'Remetente',
      statusCard:       'Status',
      encryption:       'Criptografia',
      lastSaved:        'Salvo pela última vez',
      testSentTo:       'E-mail de teste enviado para {email}!',
      host:             'Host SMTP',
      port:             'Porta',
      user:             'Usuário',
      password:         'Senha',
      fromEmail:        'E-mail do remetente',
      fromName:         'Nome do remetente',
      secure:           'Usar SSL / TLS',
      test:             'Enviar e-mail de teste',
      testSent:         'E-mail de teste enviado com sucesso!',
      save:             'Salvar configurações SMTP',
      noEncryption:     'Sem criptografia (Porta 25)',
      starttls:         'STARTTLS (Porta 587)',
      tls:              'SSL/TLS (Porta 465)',
      activeLabel:      'SMTP ativo',
      activeNotice:     'Os e-mails de convite e as notificações do sistema são enviados através desta configuração SMTP.',
      activeFallback:   'Se o SMTP não estiver configurado, o Firebase Authentication é utilizado automaticamente como alternativa.',
      secretBadge:      'Guardado como segredo do Firebase',
      secretHint:       'Este segredo não fica na base de dados e nunca é carregado no browser. É definido no servidor, no projeto Firebase, com o comando abaixo. Introduza o valor quando lhe for pedido ou passe-o por pipe com printf %s, nunca com echo: o echo acrescenta uma quebra de linha, que fica guardada sem alterações no segredo.',
    },

    api: {
      eyebrow:          'Configurações · API',
      title:            'Tokens de API',
      subtitle:         'Tokens de acesso para a API REST pública',
      tokensTitle:      'Tokens de API',
      tokensSubtitle:   'Tokens para o acesso API externo — desta empresa e globais',
      generate:         'Gerar token',
      noCompany:        'Selecione primeiro uma empresa.',
      empty:            'Ainda não há tokens de API.',
      colScope:         'Âmbito',
      scopeGlobal:      'Global',
      scopeCompany:     'Empresa',
      scopeGlobalHint:  'Válido para todas as empresas.',
      scopeCompanyHint: 'Válido apenas para esta empresa.',
      globalLabel:      'Token global',
      globalHint:       'Válido para todas as empresas em vez de apenas para esta. Utilize-o só para acessos internos e atribua-lhe um nome que identifique quem o utiliza.',
      revokeGlobalHint: 'Este token é válido para todas as empresas. Após a revogação, todas as empresas perdem imediatamente o acesso através dele.',
      colName:          'Nome',
      colPrefix:        'Prefixo',
      colStatus:        'Estado',
      colCreated:       'Criado',
      colExpires:       'Válido até',
      colLastUsed:      'Última utilização',
      statusActive:     'Ativo',
      statusRevoked:    'Revogado',
      neverExpires:     'Sem validade',
      revoke:           'Revogar token',
      tokenCreated:     'Token gerado – guarde-o agora!',
      tokenOnceHint:    'O token é mostrado apenas uma vez. Copie-o para um local seguro.',
      connectionTitle:  'Conexão',
      authLabel:        'Autenticação',
      contentTypeLabel: 'Content-Type',
      connectionNote:   'Envie o token em cada pedido no cabeçalho Authorization como Bearer token.',
      createTitle:      'Gerar um novo token de API',
      createBody:       'Opcionalmente atribua um nome e uma data de validade.',
      nameLabel:        'Nome (opcional)',
      namePlaceholder:  'p. ex. Integração Payfix',
      expiresLabel:     'Data de validade (opcional)',
      expiresHint:      'Deixe vazio para um token sem validade.',
      revokeTitle:      'Revogar token?',
      revokeBody:       'O token «{name}» será revogado de forma irreversível. Todas as integrações que o utilizam perderão o acesso imediatamente.',
      revokeConfirm:    'Sim, revogar',
    },
  },

  companySelect: {
    title:    'Selecionar empresa',
    subtitle: 'Selecione uma empresa para continuar.',
    search:   'Pesquisar empresa …',
    empty:    'Nenhuma empresa encontrada.',
    continue: 'Continuar',
    notFound: 'Nenhuma empresa encontrada para «{query}»',
    // ⚠ ENTFALLEN AM 2026-08-22 (T-M24.3, REQ-OPS-058 (2)) — die vier Saetze
    // der Nachlade-Leiste (`limitReached`, `loadMore`, `loadedCount`,
    // `endOfList`) sind in allen sechs Sprachen zurueckgenommen; der deutsche
    // Wortlaut steht in `de.ts`. Die Firmen-Auswahl laedt alle Firmen auf
    // einmal. Die gleichnamigen Saetze unter `printers.*` bleiben stehen.
  },

  location: {
    offline: 'Localização offline',
  },

  fastline: {
    cameraOpen:    'Abrir câmara',
    orderNumber:   'Número do pedido',
    search:        'Pesquisar',
    scan:          'Digitalizar',
    scanQr:        'Digitalizar código QR',
    // O teclado tátil da introdução manual (REQ-SC-099, T-M23.3).
    keypadOpen:      'Introduzir código',
    keypadTitle:     'Introduzir o código manualmente',
    keypadHint:      'Alternativa quando o código QR não é legível. O leitor e a câmara continuam a ser a via normal.',
    keypadSearch:    'Procurar pedido',
    keypadBackspace: 'Apagar o último carácter',
    // Os dois ecrãs de resultado (REQ-SC-100, T-M23.4).
    pickedUpTitle:     'Levantado',
    pickedUpDone:      'O pedido está concluído e foi removido da lista.',
    pickedUpAutoClose: 'Esta janela fecha-se sozinha em {seconds} segundos.',
    notFoundTitle:     'Pedido não encontrado',
    notFoundText:      'Este código é desconhecido.',
    notFoundRescan:    'Ler novamente',
    notFoundManual:    'Introduzir o código manualmente',
    scanHint:      'Coloque o código QR dentro da moldura',
    // Resposta da digitalização movida para `screen.*` com T-M12.21 (REQ-SC-082).

    // A única ação principal da janela de levantamento (REQ-SC-098 (4)).
    pickUp:        'Levantar',
    scannerReady:     'Leitor pronto',
    scannerReadyHint: 'Digitalize o código QR do talão — o pedido abre-se sozinho.',
  },

  kitchen: {
    toCook:           'Para cozinhar',
    tickets:          'Tickets',
    allDone:          'Tudo concluído',
    openItems:        'Artigos em aberto',
    open:             'Aberto',
    inProgress:       'Em processamento',
    start:            'Iniciar',
    markReady:        'Pronto para retirada',
    done:             'Concluído',
    emptyOpen:        'Nenhum pedido aberto',
    emptyInProgress:  'Nenhum pedido em processamento',
    emptyReady:       'Nenhum pedido pronto para retirada',
    emptyOrders:      'Nenhum pedido',
    doneAll:          'Tudo pronto!',
    actionFailed:     'Não guardado. Toque novamente.',
    actionStale:      'O pedido foi alterado. A vista atualiza-se sozinha.',
    actionExpired:    'A sessão deste ecrã expirou. Recarregue a página.',
    // Agrupamento e início por prato (REQ-SC-068, T-M12.8). O identificador do
    // prato é uma CADEIA usada literalmente — `Prato 2`, também `Prato Ürli`.
    gangLabel:        'Prato {gang}',
    startGang:        'Iniciar prato',
    // Artikel-Countdown (REQ-SC-071): Aufschrift der Startschaltflaeche.
    timerStart:       '{minutes} min',
    // Alterações posteriores (REQ-SC-072, T-M12.7): rótulo do botão
    // vermelho quando a quantidade resultante desce a zero ou abaixo.
    fullyCancelled:   'Totalmente anulado',
    // Diálogo de resultado da leitura de retirada (REQ-SC-073, T-M12.10). O
    // MOTIVO EXPLÍCITO de REQ-SC-087 está desde T-M12.54 em
    // `screen.scanNotReady`: é a mesma frase nas três vistas.
    tableNumber:      'Mesa {number}',
    scanReceived:     'Receção',
    scanNoDetail:     'Os detalhes deste pedido não estão disponíveis neste ecrã.',
    // Estado do cartão na vista Fastline (REQ-SC-097 (2)) — apenas
    // apresentação; o estado de tratamento no Firestore continua `open`.
    waitingForPickupScan: 'A aguardar a leitura de levantamento',
  },

  screen: {
    keyPrompt:      'Inserir chave de exibição',
    keyPlaceholder: 'Chave de exibição',
    connect:        'Conectar',
    connecting:     'Conectando …',
    invalidKey:     'Chave de exibição inválida.',
    notPrinted:     'Comprovativo ainda não impresso',
    limitReached:   'São mostrados apenas os {count} pedidos mais recentes.',
    // Vista desativada (REQ-SC-079, T-M12.19).
    viewDisabledTitle:       'Esta vista está desativada',
    viewDisabledKitchenTv:   'A Kitchen TV não está ativada para este canal.',
    viewDisabledAbholscreen: 'O ecrã de levantamento não está ativado para este canal.',
    viewDisabledChannel:     'Canal: {name}',
    viewDisabledHelp:        'Pode ativar a vista para este canal em «Impressoras» no painel de controlo.',
    // Assunção do modo de ecrã (REQ-SC-104 (5), T-M25.3) — por canal está
    // ativo exatamente um modo; o ecrã recém-aberto nomeia o modo ativo e só
    // escreve após a confirmação.
    modeNameNormal:   'Kitchen TV',
    modeNameLight:    'Kitchen TV Light',
    modeNameFastline: 'Fastline',
    takeoverTitle:    'Está ativo outro modo',
    takeoverWarning:  'Neste canal está atualmente a correr «{active}». Se iniciar «{own}» aqui, «{active}» será desativado.',
    takeoverIdle:     'Este ecrã ainda não assumiu «{own}».',
    takeoverConfirm:  'Iniciar «{own}» aqui',
    takeoverRunning:  'A assumir …',
    takeoverHint:     'Enquanto não confirmar, nada muda – o outro ecrã continua a funcionar.',
    // Resposta da digitalização de levantamento (REQ-SC-082, T-M12.21) — partilhada pelos três ecrãs.
    alreadyPickedUp:       'Já levantado',
    alreadyPickedUpAt:     'Levantado em {time}',
    alreadyPickedUpNoTime: 'Hora não registada',
    scanFound:             'Pedido encontrado',
    scanCompleted:         'Concluído',
    scanNotFound:          'Nenhum pedido correspondente encontrado',
    scanError:             'Erro de digitalização',
    scanNotReady:          'A leitura ficou registada. O encerramento só ocorre a partir de «Pronto para levantamento».',
    // Introdução e leitura no ecrã de levantamento (REQ-SC-012, T-M12.23).
    pickupPrompt: 'Introduza ou digitalize o número do pedido',
    pickupNumber: 'Número do pedido',
    pickupSubmit: 'Levantar',
    // Conclusão em bloco (REQ-SC-083, T-M12.22). A confirmação tem de dizer o
    // que é concluído e quantos pedidos — e que não se imprime nada.
    completeAll:        'Concluir todos',
    completeAllTitle:   'Concluir todos os pedidos?',
    completeAllBody:    '{count} pedidos em «Em processamento» e «Pronto para retirada» serão concluídos. É uma limpeza do ecrã: não se imprime nada nem se emite qualquer talão.',
    completeAllChunks:  'Há mais de {max} pedidos. São concluídos em {calls} passos; se um passo falhar, os pedidos dos passos seguintes ficam por concluir.',
    completeAllConfirm: 'Sim, concluir {count}',
    completeAllDone:    '{count} pedidos concluídos.',
    completeAllNoScan:  'Não levantados com um código QR: {count} pedidos não têm qualquer leitura de levantamento. Concluir mesmo assim?',
    // Etiqueta de origem no canal Fast Line (REQ-SC-095). «OrderMood» e um
    // nome proprio e mantem-se igual em todos os idiomas.
    originOrderMood: 'OrderMood',
    originRegister:  'Caixa',
  },

  // ── Das Kennzeichen des Testsystems (T-M32.7, REQ-OPS-061) ────────────────
  // Der Streifen am oberen Rand der Verwaltungsoberflaeche. Uebersetzt wird
  // allein das WORT „Testsystem"; `{projektId}` ist ein technischer Name und
  // steht in jeder Sprache gleich (REQ-OV-002, REQ-OV-008).
  // Der Emulator-Wortlaut ist der Sonderfall des lokalen Entwicklungswegs: dort
  // lautet die Projekt-ID `printerque-prod`, weil sie beim Emulatorlauf nur die
  // Audience der ID-Token ist (REQ-OPS-064 (a)) — ohne den Zusatz stuende ein
  // Widerspruch auf dem Bildschirm.
  umgebung: {
    testBanner:         'SISTEMA DE TESTE · {projektId}',
    testBannerEmulator: 'SISTEMA DE TESTE · {projektId} · Emulador',
  },
}
